import { GetServerSideProps } from 'next';

import { wrapper } from 'src/redux/store/store';
import { Page } from 'src/__generated__/graphqlTypes';
import { getAboutPage } from 'src/api/pageApi';
import { MainContainer } from 'src/components/dynamic';
import { setPages } from 'app-redux/actions/pageActions';
import { calculateCustomerType } from 'lib/session.service';
import { ServerSideRenderingContext } from 'types/objectTypes';
import { setAuthenticatedState, setUser } from 'app-redux/actions/authActions';
import {
  setMobileViewWidthState,
  setOAPlatform,
  setViewerDevice,
} from 'app-redux/actions/appActions';
import { CustomerType, ViewerDevice } from 'constants/enums';
import {
  extractSlug,
  recognizeOAPlatform,
  recognizeViewerDevice,
} from 'lib/page.service';
import withMiddleware, { commonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';

const handler = async ({
  // @ts-ignore
  locale,
  req,
  res,
  store,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  const session = req?.session?.getSession();
  const customerType = calculateCustomerType(req.session);

  const isAuthorized = customerType === CustomerType.EC;
  try {
    const slug = extractSlug(req.url, locale);

    if (!slug) {
      return { notFound: true };
    }

    const page = await getAboutPage({ slug, customerType, preview });

    if (page) {
      store.dispatch(setPages<Page>({ key: slug, value: page }));
      store.dispatch(setAuthenticatedState(isAuthorized));
      store.dispatch(setUser(session));
      const viewerDevice = recognizeViewerDevice(req.headers);
      const oaPlatform = recognizeOAPlatform(req.headers);
      const isRequestFromMobile = viewerDevice === ViewerDevice.MOBILE;

      store.dispatch(setMobileViewWidthState(isRequestFromMobile));
      store.dispatch(setViewerDevice(viewerDevice));
      store.dispatch(setOAPlatform(oaPlatform));
      setDefaultCacheBehavior(120, res);

      return { props: { } };
    }

    return { props: { } };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(handler, { prior: commonMiddleware }));

export default MainContainer;
